function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
import React from 'react';
import { atom } from 'jotai';
import { useAtomValue } from 'jotai/utils';
export var EventEmitter = /*#__PURE__*/function () {
  function EventEmitter() {
    _classCallCheck(this, EventEmitter);
    _defineProperty(this, "subscriptions", new Set());
  }
  _createClass(EventEmitter, [{
    key: "useSubscription",
    value: function useSubscription(callback) {
      var _this = this;
      // eslint-disable-next-line react-hooks/rules-of-hooks
      var callbackRef = React.useRef();
      callbackRef.current = callback;
      // eslint-disable-next-line react-hooks/rules-of-hooks
      React.useEffect(function () {
        function subscription(value) {
          if (callbackRef.current) {
            callbackRef.current(value);
          }
        }
        _this.subscriptions.add(subscription);
        return function () {
          _this.subscriptions.delete(subscription);
        };
      }, []);
    }
  }, {
    key: "emit",
    value: function emit(value) {
      this.subscriptions.forEach(function (subscriber) {
        subscriber(value);
      });
    }
  }, {
    key: "clear",
    value: function clear() {
      this.subscriptions.clear();
    }
  }]);
  return EventEmitter;
}();
export var EEvent;
(function (EEvent) {
  EEvent["ON_PERIOD_CHANGED"] = "ON_PERIOD_CHANGED";
  EEvent["ON_PAY_VALIDATE_FPX"] = "ON_PAY_VALIDATE_FPX";
  EEvent["ON_VALIDATE_FAIL_FPX"] = "ON_VALIDATE_FAIL_FPX";
  EEvent["ON_PAY_WITH_FPX"] = "ON_PAY_WITH_FPX";
  EEvent["ON_PAY_FAIL_FPX"] = "ON_PAY_FAIL_FPX";
  EEvent["ON_VALIDATE_FAIL_XENDIT"] = "ON_VALIDATE_FAIL_XENDIT";
  EEvent["ON_PAY_FAIL_XENDIT"] = "ON_PAY_FAIL_XENDIT";
  EEvent["ON_PAY_VALIDATE_XENDIT"] = "ON_PAY_VALIDATE_XENDIT";
  EEvent["ON_PAY_WITH_XENDIT"] = "ON_PAY_WITH_XENDIT";
  EEvent["ON_PAY_AND_BIND_CLICK"] = "ON_PAY_AND_BIND_CLICK";
  EEvent["ON_PAY_SUCCESS"] = "ON_PAY_SUCCESS";
  EEvent["ON_REFRESH"] = "ON_REFRESH";
  EEvent["ON_PAY_WITH_PAYNOW"] = "ON_PAY_WITH_PAYNOW";
  EEvent["ON_PAY_VALIDATE_PAYNOW"] = "ON_PAY_VALIDATE_PAYNOW";
  EEvent["ON_PAY_WITH_UMS"] = "ON_PAY_WITH_UMS";
})(EEvent || (EEvent = {}));
export var emitter = new EventEmitter();
export var eventAtom = atom({
  event$: emitter
});
export function useEventAtom() {
  return useAtomValue(eventAtom);
}